import React, { useEffect, useState } from "react";
import { utf8_to_b64 } from "../../functions";
import { useNavigate } from "react-router-dom";

export const Login = () => {
  const navigate = useNavigate();

  const [id, setId] = useState("");
  const [pw, setPw] = useState("");

  const login: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    if (
      process.env.REACT_APP_ID !== utf8_to_b64(id) ||
      process.env.REACT_APP_PW !== utf8_to_b64(pw)
    ) {
      alert("잘못된 계정정보입니다.");
      return;
    }
    sessionStorage.setItem("isLogin", "true");
    navigate("/");
  };

  useEffect(() => {
    console.log(process.env.REACT_APP_COUNT);
  }, []);

  return (
    <form
      onSubmit={login}
      className="bg fixed p-16 bg-white p-center w-[616px] h-[616px] rounded-2xl"
    >
      <h2 className="font-bold text-center ">
        <p className="mb-4 text-3xl">로그인</p>
      </h2>
      <div className="my-14">
        <p className="mb-2 font-bold text-gray-400">아이디</p>
        <input
          value={id}
          onChange={(e) => setId(e.target.value)}
          className="w-full p-4 border border-black rounded-xl"
          type="text"
        />
      </div>
      <div className="my-14">
        <p className="mb-2 font-bold text-gray-400">비밀번호</p>
        <input
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          className="w-full p-4 border border-black rounded-xl"
          type="password"
        />
      </div>
      <button
        type="submit"
        className="w-full p-4 text-xl text-white bg-blue-500 rounded-xl"
      >
        로그인
      </button>
    </form>
  );
};
